<template>
  <section class="page-content">
    <div>
      <home-slideshow />
    </div>

    <div class="home-content">
      <h2>Bienvenue !</h2>
      <hr class="page-separator"/>
      <div class="home-speech-box">
        L'ecole de Brens vous accueille sur son nouveau site internet.
        <br/>
        <br/>
        Consultez-le sans aucune moderation !
      </div>

      <h3>Articles récents</h3>

      <article-list :articleList="allArticles" :display="'all'" :stopScrolling="stopLoading" />

      <div class="see-more-box" v-if="loggedIn">
        <router-link to="/articles" class="see-more-label">--- Voir plus ---</router-link>
      </div>

    </div>
   
  </section>
</template>

<style scoped>
  @import '../assets/styles/global-styles.css';
  @import '../assets/styles/variables.css';

  .home-content {
    padding: 0 calc(25px * var(--margin-factor));
  }

  .home-speech-box {
    margin-top: 10px;
    margin-bottom: 60px;
  }

  .see-more-box {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .see-more-label {
    text-decoration: none;
  }

  h3 {
    color: var(--dark-text-color);
  }
</style>


<script lang="ts">
  import ArticleList from '@/components/articles/ArticleList.component.vue';
  import HomeSlideshow from '@/components/home/HomeSlideshow.component.vue';
  import { AuthenticationService } from '@/services/authentication.service';
  import { Component, Vue } from 'vue-property-decorator';
  import * as UrlConsts from '@/scripts/UrlConsts';
  import { Article } from '@/interfaces/arcticles/Article.entity';
  import axios from 'axios';
  import { Utils } from '@/scripts/Utils';


  @Component({
    components: {
      'home-slideshow': HomeSlideshow,
      'article-list' : ArticleList
    },
  })
  export default class Home extends Vue {
    allArticles : Array<Article> = [];
    stopLoading= false;
    loadArticlesCount = 5;
    loggedIn = false;

    mounted()  : void {
      this.loggedIn = AuthenticationService.isLoggedIn();
      this.loadAllArticles(new Date());
    }

    /**
     * @desc charge les articles limités au nombre "loadArticlesCount" plus anciens que la date "lastDate"
     */
    loadAllArticles(lastDate : Date) : void {
      if(this.stopLoading) return;

      const headers = AuthenticationService.getRequestHeader();
      const query = '?' + Utils.createUrlQuery({limit: this.loadArticlesCount})

      this.stopLoading = true;
      axios
        .get(  UrlConsts.getAllArticlesLimited + query, headers)
        .then((response) => {
          const responseArray = response.data;
          if(!responseArray || !responseArray.length || responseArray.length < this.loadArticlesCount) {
            this.stopLoading = true;
          }
          else {
            setTimeout(() => {
              this.stopLoading = false;
            }, 50);
          }
          this.allArticles = this.allArticles.filter((x: Article) => !responseArray.find((y : any) => y.id === x.id));
          this.allArticles = this.allArticles.concat(responseArray.map((x: any) => new Article(x)));
        })
        .catch(error => console.log(error))
    }
  }
</script>